import { inject, Injector } from '@angular/core';
import { signalStore, withMethods, withProps, withState } from '@ngrx/signals';
import { initialTitoloAutorizzativoState } from './titolo_autorizzativo.state';
import { getTitoloAutorizzativo } from './titolo_autorizzativo.utility';
import { GetTitoloAutorizzativoGQL } from '../../_graphql/generated';

export const TitoloAutorizzativoStore = signalStore(
  { providedIn: 'root' },
  withState(initialTitoloAutorizzativoState),
  withProps(() => ({
    getter: inject(GetTitoloAutorizzativoGQL),
  })),
  withMethods(({ getter, ...store }, injector = inject(Injector)) => ({
    init: getTitoloAutorizzativo(injector, store, getter),
  })),
);
